import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import DailyPlannerDataInput from "../../../components/NewsLetter/DailyPlannerDataInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getDailyPlannerData, getSingleDailyPlannerData, getSingleWeeklyPlannerData } from "../../../utils/ApiCalls/DailyPlanner";

const EditDailyPlanner = () => {
  const params = useParams();
  const [newsletter, setSailingData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Daily Planner",
      route: "/daily-planner",
    },
    {
      title: "Manage Cruise",
      route: "/shore/daily-planner/genting-dream/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getDailyPlannerData({ id: value });
   
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setSailingData(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={params.vessel.replace("-", " ")}>
      <CustomHeaderTitle title={"Manage Daily Planner"} />
      <HeaderBread
        navigation={navigation}
        title={"Manage Daily Planner"}
      ></HeaderBread>
      {newsletter && <DailyPlannerDataInput newsletter={newsletter} />}
    </Layout>
  );
};

export default EditDailyPlanner;
